import Model from '../Model'

export default class PackageNew extends Model {
    static parseAttributes(attributes = {}) {
        attributes = this.parseDropdownAttributes(attributes, ['package_id']);
        return attributes
    }

    static async find(packageReference) {
        const data = await Http.get(route('api.v2.organization.package', {package_reference: packageReference}), {})
        return this.make(data)
    }

    static async findEstimation(packageReference) {
        const data = await Http.get(route('api.v2.estimation.package', {package_reference: packageReference}), {})
        return this.make(data)
    }

    static cache = new Map()

    static async search(term) {
        let o = PackageNew.cache.get(term ? term : '#|#@|');
        if (!o || (o.expires > new Date().getTime())) {
            o = !o ? {} : o;
            o.loading = true
            PackageNew.cache.set(term ? term : '#|#@|', o);
            o = {
                data: await Http.get(route('api.v2.organization.packages.search') + '?search=' + encodeURIComponent(term), {}),
                expires: new Date().getTime() + 500,
                loading: false,
            };
            PackageNew.cache.set(term ? term : '#|#@|', o);
        }
        if (o.loading) {
            return this.make(await Promise.resolve(d.data))
        }
        return this.make(o.data);
    }

    static async all() {
        const data = await Http.get(route('api.v2.organization.packages.search',), {})
        return this.make(data)
    }

    async updateStatus(status) {
        await Http.put(route('api.v2.organization.package.status', {status: status}), {})
        return this.make(data)
    }

    async updateCRMSystemInUse(crm) {
        const success = await Http.put(route('api.v2.organization.package.crm-system-in-use', {id: this.id}), {'CRMSystemInUse': crm})
        let o = await Http.get(route('api.v2.organization.package', {package_reference: this.referenceNumber}), {})
        return Object.assign(this, o)
    }

}
